import { render, staticRenderFns } from "./TrainingDocs.vue?vue&type=template&id=15c32291&"
import script from "./TrainingDocs.vue?vue&type=script&lang=js&"
export * from "./TrainingDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports